(function () {
  'use strict';

  // ── mobile drawer ────────────────────────────────────────────
  var toggle = document.querySelector('[data-drawer-toggle]');
  var drawer = document.querySelector('[data-drawer]');
  if (toggle && drawer) {
    toggle.addEventListener('click', function () {
      var open = drawer.getAttribute('data-open') === 'true';
      drawer.setAttribute('data-open', String(!open));
      toggle.setAttribute('aria-expanded', String(!open));
    });
  }

  // ── slideshows (hero strip + product gallery) ────────────────
  document.querySelectorAll('[data-slides]').forEach(function (strip) {
    var slides = [].slice.call(strip.querySelectorAll('.strip__slide'));
    var dots = [].slice.call(strip.querySelectorAll('.strip__dot'));
    function hydrate(k) {
      var s = slides[k]; if (!s) return;
      var img = s.querySelector('img[data-src]'); if (!img) return;
      if (img.getAttribute('data-srcset')) img.setAttribute('srcset', img.getAttribute('data-srcset'));
      img.setAttribute('src', img.getAttribute('data-src'));
      img.removeAttribute('data-src'); img.removeAttribute('data-srcset');
    }
    // Desktop shows every photo in a mosaic, so load them all (they stay native-lazy).
    if (window.matchMedia('(min-width: 900px)').matches) {
      slides.forEach(function (s, k) { hydrate(k); });
    } else {
      // Phones: load photo 2 once the page has finished, the rest when reached.
      window.addEventListener('load', function () { setTimeout(function () { hydrate(1); }, 300); });
    }
    if (slides.length < 2) return;
    var i = 0;
    function show(n) {
      i = (n + slides.length) % slides.length;
      hydrate(i); hydrate(i + 1);
      slides.forEach(function (s, k) { s.setAttribute('data-active', String(k === i)); });
      dots.forEach(function (d, k) { d.setAttribute('data-active', String(k === i)); });
    }
    var prev = strip.querySelector('[data-prev]');
    var next = strip.querySelector('[data-next]');
    if (prev) prev.addEventListener('click', function () { show(i - 1); });
    if (next) next.addEventListener('click', function () { show(i + 1); });
    dots.forEach(function (d, k) { d.addEventListener('click', function () { show(k); }); });
    var x = null;
    strip.addEventListener('touchstart', function (e) { x = e.changedTouches[0].clientX; }, { passive: true });
    strip.addEventListener('touchend', function (e) {
      if (x === null) return;
      var dx = e.changedTouches[0].clientX - x;
      if (Math.abs(dx) > 40) show(dx < 0 ? i + 1 : i - 1);
      x = null;
    }, { passive: true });
  });

  // ── variant picker ───────────────────────────────────────────
  document.querySelectorAll('[data-variants]').forEach(function (root) {
    var data = {};
    try { data = JSON.parse(root.querySelector('[data-variant-json]').textContent); } catch (e) { return; }
    var idField = root.querySelector('[name="id"]');
    var priceEls = document.querySelectorAll('[data-variant-price]');
    var btns = [].slice.call(root.querySelectorAll('.variants__opt'));

    btns.forEach(function (b) {
      b.addEventListener('click', function () {
        if (b.hasAttribute('disabled')) return;
        var v = data[b.getAttribute('data-variant-id')];
        btns.forEach(function (o) { o.setAttribute('aria-pressed', String(o === b)); });
        if (idField) idField.value = b.getAttribute('data-variant-id');
        priceEls.forEach(function (el) { if (v) el.innerHTML = v.price_html; });
      });
    });
  });

  // ── quantity steppers ────────────────────────────────────────
  document.querySelectorAll('.qty').forEach(function (q) {
    var input = q.querySelector('input');
    q.querySelectorAll('button').forEach(function (b) {
      b.addEventListener('click', function () {
        var step = b.getAttribute('data-step') === 'up' ? 1 : -1;
        var n = parseInt(input.value, 10) || 1;
        input.value = Math.max(1, n + step);
        if (input.form && input.form.hasAttribute('data-cart-update')) input.form.submit();
      });
    });
  });
})();

/* Collection type filter + progressive reveal. Chips filter every card in the
   collection; the grid reveals one batch at a time. */
(function () {
  var grid = document.querySelector('[data-reveal-grid]');
  if (!grid) return;
  var bar = document.querySelector('[data-filter]');
  var cards = [].slice.call(grid.querySelectorAll('.card'));
  var label = document.querySelector('[data-count-label]');
  var moreBtn = document.querySelector('[data-reveal-more]');
  var step = parseInt(grid.getAttribute('data-reveal-step'), 10) || 24;
  var totalLabel = label ? label.textContent : '';
  var want = '';
  var shown = step;

  function render() {
    var matched = cards.filter(function (c) {
      return !want || c.getAttribute('data-type') === want;
    });
    cards.forEach(function (c) { c.hidden = true; });
    matched.slice(0, shown).forEach(function (c) { c.hidden = false; });
    if (label) {
      label.textContent = want ? matched.length + (matched.length === 1 ? ' piece' : ' pieces') : totalLabel;
    }
    if (moreBtn) {
      moreBtn.hidden = matched.length <= shown;
      moreBtn.textContent = 'Browse more (' + Math.min(shown, matched.length) + ' of ' + matched.length + ')';
    }
  }

  if (moreBtn) {
    moreBtn.addEventListener('click', function () {
      shown += step;
      render();
    });
  }

  // Sort: server-side via ?sort_by=, carrying the active chip across the reload.
  function goSort(value) {
    var url = new URL(window.location.href);
    url.searchParams.set('sort_by', value);
    url.searchParams.delete('page');
    url.hash = want ? 'type=' + encodeURIComponent(want) : '';
    window.location.href = url.toString();
  }
  var sortSel = document.querySelector('[data-sort]');
  if (sortSel) {
    sortSel.addEventListener('change', function () { goSort(sortSel.value); });
  }
  var sortToggle = document.querySelector('[data-sort-toggle]');
  var sortMenu = document.querySelector('[data-sort-menu]');
  if (sortToggle && sortMenu) {
    var items = [].slice.call(sortMenu.querySelectorAll('[data-sort-value]'));
    var setOpen = function (open) {
      sortMenu.hidden = !open;
      sortToggle.setAttribute('aria-expanded', open ? 'true' : 'false');
      if (open) (sortMenu.querySelector('.is-on') || items[0]).focus();
    };
    sortToggle.addEventListener('click', function (e) {
      e.stopPropagation();
      setOpen(sortMenu.hidden);
    });
    items.forEach(function (item, i) {
      item.addEventListener('click', function () { goSort(item.getAttribute('data-sort-value')); });
      item.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowDown') { e.preventDefault(); items[(i + 1) % items.length].focus(); }
        if (e.key === 'ArrowUp') { e.preventDefault(); items[(i - 1 + items.length) % items.length].focus(); }
      });
    });
    document.addEventListener('click', function (e) {
      if (!sortMenu.hidden && !sortMenu.contains(e.target)) setOpen(false);
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !sortMenu.hidden) { setOpen(false); sortToggle.focus(); }
    });
  }

  if (bar) {
    var chips = [].slice.call(bar.querySelectorAll('.chip'));
    chips.forEach(function (chip) {
      chip.addEventListener('click', function () {
        want = chip.getAttribute('data-type') || '';
        shown = step;
        chips.forEach(function (c) {
          var on = c === chip;
          c.classList.toggle('chip--on', on);
          c.setAttribute('aria-pressed', on ? 'true' : 'false');
        });
        render();
      });
    });

    var m = window.location.hash.match(/^#type=(.+)$/);
    if (m) {
      var fromHash = decodeURIComponent(m[1]);
      chips.forEach(function (c) {
        if (c.getAttribute('data-type') === fromHash) c.click();
      });
    }
  }

  render();
})();
